<template>
<div>
    <el-row class="cs-contentContainer">
        <el-col :span="4" class="cs-main-left-container">
            <navigator></navigator>
        </el-col>
        <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
            <div class="cs-fullHeight cs-contentContainer-right">
                <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
                    <el-row>
                        <el-col>
                            <span class="cs-title">{{isOnline ? "线上课程" : "激活课程"}}</span>
                            <el-tabs v-model="activeCourseType" type="card" @tab-click="loadCourseByType">
                                <el-tab-pane :key="item.id" v-for="item in courseTypes" :label="item.name" :name="item.id">
                                    <el-row class="middle-align" v-if="item.id == 1">
                                        <el-col :xs="24" :lg="24">
                                            <el-select placeholder="请选择学校" v-model="selectedUniversityGroupNumber" size="medium" @change="onUniversityChanged" class="cs-activeCourse-university margin-right-20px">
                                                <el-option v-for="item in universityList" :key="item.UniversityGroup" :label="item.UniversityAbbrs" :value="item.UniversityGroup">
                                                </el-option>
                                            </el-select> 
                                            <span>本学期：{{currentTerm.DisplayLable}}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="grid-content" v-if="item.id == 1">
                                        <el-col>
                                            <course-operator :courseList="courseList" :groupNumber="selectedUniversityGroupNumber" :usage='"teacher"'></course-operator>
                                        </el-col>
                                    </el-row>

                                    <el-row class="middle-align" v-if="item.id == 2">
                                        <el-col :xs="24" :lg="24">
                                            <el-select placeholder="请选择业务" v-model="training.selectedCategory" @change="getTerms" size="medium" class="cs-activeCourse-university margin-right-20px">
                                                <el-option v-for="item in training.categories" :key="item.TrainingCategoryId" :label="item.TrainingCategoryName" :value="item.TrainingCategoryId">
                                                </el-option>
                                            </el-select> 
                                            <!-- <el-select placeholder="请选择学期" v-model="training.selectedTerm" size="medium" class="cs-activeCourse-university margin-right-20px">
                                                <el-option v-for="item in training.terms" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
                                                </el-option>
                                            </el-select> -->
                                            <!-- <el-button class="course-add" type="primary" plain icon="el-icon-plus" @click="handleAdd">添加课程</el-button> -->
                                        </el-col>
                                    </el-row>
                                     <el-row class="grid-content" v-if="item.id == 2">
                                        <el-col>
                                            <course-operator :courseList="training.activeCourses" :usage='"activeTraining"'></course-operator>
                                        </el-col>
                                    </el-row>

                                </el-tab-pane>
                            </el-tabs>
                            <el-row class="grid-content">
                                <el-col>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" width="600px" :visible.sync="showAddCourse" top="8vh">
                <add-active-course :training="training" v-on:closeAddCourse="oncloseAddCourse"></add-active-course>
            </el-dialog>
        </el-col>
    </el-row>
</div>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
    .grid-content {
        margin-top: 15px;
        .cs-schedule-buttonContainer {
            text-align: right;
        }
        .middle-align {
            vertical-align: middle;
        }
    }
}
.course-add{
    margin-left:170px;
}
</style>

<script>
import global_ from "../../core/global";
import navigator from "../../components/navigator";
import courseOperator from "../../components/courseOperator";
import addActiveCourse from "../../components/addActiveCourse";

import {
    getUniversityGroups,
    getCurrentTerm,
    getTrainingTerms
} from "../../service/common.service";

import {
    getTeacherActiveCourses,
    getTeacherTrainingActiveCourses,
    getTeacherCourseList
} from "../../service/teacherCourse.service.js"

export default {
    data() {
        return {
            isOnline: global_.isOnlineCourse,
            loading: false,
            courseTypes: [{
                id: "1",
                name: "大学补习"
            }],
            activeCourseType: "1",
            selectedUniversityGroupNumber: "",
            universityList: [],
            currentTerm: {},
            dataSource: [],
            courseList: [],
            proccessing: false,
            showAddCourse: false,
            training:{
                categories : [],
                terms : [],
                selectedTerm : "",
                selectedCategory : "",
                activeCourses : []
            }
            
        };
    },
    components: {
        navigator,
        courseOperator,
        addActiveCourse
    },
    computed: {},
    created() {
        this.getTeacherCategories();
        this.loadTeacherActiveCourses();
        getCurrentTerm().then(result => {
            if (!!result && result.success) {
                this.currentTerm = result.data;
            }
        });

        let groupNumber = this.$route.query.groupNumber;
        if (groupNumber && groupNumber > 0) {
            this.selectedUniversityGroupNumber = parseInt(groupNumber);
            this.onUniversityChanged();
        }
    },
    methods: {
        onUniversityChanged() {
            this.courseList = this.dataSource.filter(course => {
                return course.UniversityGroup == this.selectedUniversityGroupNumber;
            })
        },
        loadTeacherActiveCourses() {
            getTeacherActiveCourses().then(result => {
                if (!!result && result.success) {
                    this.dataSource = result.data;
                    this.loadUniversityGroups();
                } else {
                    this.$message.error(result.message);
                }
            });
        },
        loadUniversityGroups() {
            this.dataSource.forEach((item, index) => {
                let isRepeated = false;
                this.universityList.forEach(university => {
                    if (university.UniversityGroup == item.UniversityGroup) {
                        isRepeated = true;
                    }
                });
                if (!isRepeated) {
                    this.universityList.push({
                        UniversityGroup: item.UniversityGroup,
                        UniversityAbbrs: item.UniversityAbbrs
                    });
                }
                if (index == 0) {
                    this.selectedUniversityGroupNumber = item.UniversityGroup;
                }
            });
            this.onUniversityChanged();
        },

        loadCourseByType(tab, event) {
            if(this.activeCourseType == 1){
                this.loadTeacherActiveCourses();
            } else if (this.activeCourseType == 2){
                this.loadTraing();
            }
        },

        handleAdd(){
            this.showAddCourse = true;
        },

        loadTraing(){
            //业务
            if(this.training.categories && this.training.categories.length > 0){
                this.training.selectedCategory = this.training.categories[0].TrainingCategoryId;
            }

            this.getTerms();
        },

        getTeacherCategories(){
            getTeacherCourseList().then(res=>{
                if (!!res && res.success) {
                    this.training.categories = res.data.TeacherTrainingCategoryList;
                    if(this.training.categories && this.training.categories.length > 0){
                        this.courseTypes.push({
                            id:"2",
                            name:"职业培训"
                        });
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        getTerms(){
            //学期
            getTrainingTerms(false,parseInt(this.training.selectedCategory)).then(res=>{
                if (!!res && res.success) {
                    this.training.terms = res.data;
                    if(this.training.terms && this.training.terms.length > 0){
                        this.training.selectedTerm = this.training.terms[0].Id;
                    }

                    //获取老师所有的培训课程
                    this.loadTeacherTrainingActiveTraing();
                } else {
                    this.$message.error(res.message);
                }     
            });
        },

        loadTeacherTrainingActiveTraing(){
            let data = {
                termId: this.training.selectedTerm,
                termType:this.activeCourseType,
                categoryId:this.training.selectedCategory
            }
            
            getTeacherTrainingActiveCourses(data).then(res=>{
                this.training.activeCourses = res.data;
            });
        },

        oncloseAddCourse(){
            this.showAddCourse = false;

            //update course list
            this.loadTeacherTrainingActiveTraing();
        },
    },
    watch: {}
};
</script>



// WEBPACK FOOTER //
// src/page/teacher/activateCourse.vue